module.exports = __webpack_public_path__ + "img/message-send.9cb3975d.png";